var defaultClassNames = {exports: {}};

export { defaultClassNames as __module };
